export default __webpack_public_path__ + "static/speaker6-14b84c14aefd7f8f2e17f24754bd6c58.jpg";